export const motionTokens = {
  spring: {
    type: "spring",
    stiffness: 210,
    damping: 24,
  },

  hoverSpring: {
    type: "spring",
    stiffness: 320,
    damping: 20,
  },

  staggerFast: 0.04,
  staggerMedium: 0.08,

  shimmerDuration: 1.8,

  hoverLift: -3,
};

export default motionTokens;
